import { parsePhoneNumberFromString } from 'libphonenumber-js'

const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return true
  return parsePhoneNumberFromString(phoneNumber, 'GB')?.isValid()
}

export default [
  'valid-phone-number',
  'Please enter a valid phone number.',
  isValidPhoneNumber,
]
